const path = 'redux/User';
export const USER_LOGGED_IN = `${path}/USER_LOGGED_IN`;
export const USER_LOGGED_OUT = `${path}/USER_LOGGED_OUT`;